import React from 'react';
import styled from 'styled-components';
import Home_document from '../../../images/product-assets/home-document.svg';
import Setting_globe from '../../../images/product-assets/setting-globe.svg';
import Cost_Effective from '../../../images/product-assets/cost_effective.svg';
import Professional_licensing from '../../../images/product-assets/support.svg';
import Landing_money from '../../../images/product-assets/landing-money.svg';
import Shopping_cart from '../../../images/product-assets/shopping-cart.svg';
import Home_checks from '../../../images/product-assets/home-check.svg';
import Online_check from '../../../images/product-assets/online-check.svg';
import Authenticate_check from '../../../images/product-assets/authenticate-check.svg';
import Bank_check from '../../../images/product-assets/bank-check.svg';
import Safety from '../../../images/product-assets/safety.svg';
import Files_check from '../../../images/product-assets/files-check.svg';
import Person_search from '../../../images/product-assets/person-search.svg';

export const criminalCheckBulletPoints = [
    { id: 1, label: 'Instant Reports' },
    { id: 2, label: 'All States & Counties Covered' },
    { id: 3, label: 'Global Watchlist Reports' },
];

export const tcmBulletPoints = [
    { id: 1, label: 'Provides immediate alerts' },
    { id: 2, label: 'Cost effective' },
    { id: 3, label: 'Fully automated process' },
];

export const criminalCheckInfoCards = [
    {
        id: 0,
        icon: Home_document,
        alt: 'Short-Term Rental Screening',
        title: <span>Short-Term Rental Screening:</span>,
        description:
            'Landlords and property managers use criminal background checks to assess the risk of renting to individuals with a history of criminal activity, preventing issues like property damage or violent behavior.',
    },
    {
        id: 1,
        icon: Setting_globe,
        alt: 'Volunteer Organizations',
        title: <span>Volunteer Organizations:</span>,
        description:
            'Nonprofits screen volunteers to protect vulnerable populations. For instance, a youth mentoring program conducts criminal background checks to safeguard children from potential harm.',
    },
    {
        id: 2,
        icon: Cost_Effective,
        alt: 'Financial Services',
        title: <span>Financial Services:</span>,
        description:
            "Banks use criminal background checks to gauge applicants' trustworthiness for loans or services. For instance, they screen for financial fraud or embezzlement history to prevent lending to risky individuals.",
    },
    {
        id: 3,
        icon: Professional_licensing,
        alt: 'Professional Licensing',
        title: <span>Professional Licensing:</span>,
        description:
            "Licensing boards use criminal background checks to assess applicants' character. For example, medical boards ensure patient safety by screening for past criminal activity in medical license applicants.",
    },

    {
        id: 4,
        icon: Landing_money,
        alt: 'Peer-to-Peer Lending Platforms',
        title: <span>Peer-to-Peer Lending Platforms:</span>,
        description:
            'Criminal background checks on peer-to-peer lending platforms verify identities and trustworthiness. For example, they screen borrowers to prevent lending to fraudsters or loan defaulters, reducing risks for lenders.',
    },
    {
        id: 5,
        icon: Shopping_cart,
        alt: 'E-Commerce',
        title: <span>E-Commerce:</span>,
        description:
            'Criminal background checks enhance e-commerce security by verifying customer identities and preventing fraud, protecting businesses and customers from financial loss and identity theft.',
    },
    {
        id: 6,
        icon: Home_checks,
        alt: 'Online Marketplaces',
        title: <span>Online Marketplaces:</span>,
        description:
            'Criminal background checks verify seller identity and trustworthiness on online marketplaces, preventing fraud and ensuring product authenticity, boosting buyer trust and sales.',
    },
    {
        id: 7,
        icon: Online_check,
        alt: 'Gig Economy and Freelance Platforms',
        title: <span>Gig Economy and Freelance Platforms:</span>,
        description:
            'Freelance platforms use criminal background checks to verify trust, ensuring safety for workers and clients while preventing fraud and maintaining reliability.',
    },
    {
        id: 8,
        icon: Authenticate_check,
        alt: 'Authenticate for every use case',
        title: <span>Authenticate for every use case:</span>,
        description:
            'Authenticate provides swift and thorough criminal background checks, enhancing every business security measures.',
        linkText: 'Get Started ➚',
        link: 'https://portal.authenticate.com/register',
    },
];

export const criminalCheckHelpCard = [
    {
        id: 0,
        icon: Bank_check,
        title: 'Federal Level Checks',
        desc: 'Authenticate efficiently conducts searches across all accessible federal criminal and civil records, delivering precise and detailed results within 24 hours to boost business confidence in our verification services.',
        link: `https://info.authenticate.com/federal-civil-criminal-record-verification-usa`,
    },
    {
        id: 1,
        icon: Safety,
        title: 'County-Level Checks',
        desc: 'Authenticate conducts detailed verification of county criminal and civil records through trusted databases, delivering precise and compliant results. This process grants businesses essential insights in 2-3 days, depending on the county, enhancing protection against illegal activities.',
        link: `https://info.authenticate.com/county-criminal-civil-record-verification-usa`,
    },
    {
        id: 2,
        icon: Files_check,
        title: '7-Year Criminal Activity Reports',
        desc: "Authenticate's 7-Year Criminal Activity Report aggregates public and commercial data to reveal an individual's criminal history, including the nature of the crime, sex offender conviction, and much more, over seven years, helping businesses manage risks and make informed decisions.",
        link: `https://info.authenticate.com/7-year-criminal-report-usa`,
    },
    {
        id: 3,
        icon: Person_search,
        title: 'Global Watchlist Reports',
        desc: 'The Global Watchlist Search screens individuals against international sanctions and watchlists, aiding organizations in regulatory compliance and security enhancement. It cross-references identities with databases such as OFAC, the EU Consolidated List, and the UN Consolidated List, helping organizations make well-informed decisions and reduce risks of non-compliance.',
        link: `https://info.authenticate.com/global-watchlist-report`,
    },
];

const Ul = styled.ul`
    margin-left: 24px;
    padding: 10px 0;
`;

export const criminalCheckFaq = [
    {
        id: 0,
        title: 'What are Criminal Background Checks?',
        desc: "Authenticate offers multiple solutions for criminal background checks, which are vital for businesses to verify the trustworthiness and integrity of potential users, tenants, or business partners. This service accesses multiple databases to retrieve instant reports detailing individuals' criminal history, including the type and nature of crimes committed.",
        linkText: 'Learn more',
        link: 'https://info.authenticate.com/criminal-background-checks-usa',
    },
    {
        id: 1,
        title: 'Which kinds of civil cases are covered?',
        desc: (
            <>
                The offering includes civil upper and lower court searches. It provides records for
                claims as defined by state-specific thresholds:
                <Ul>
                    <li>Limited or Lower Civil cases: Involving claims of less than $25,000.</li>
                    <li>Upper or Unlimited Civil cases: Involving claims of more than $25,000.</li>
                </Ul>
            </>
        ),
        linkText: 'Learn more',
        link: 'https://info.authenticate.com/county-criminal-civil-record-verification-usa',
    },
    {
        id: 2,
        title: 'Which U.S. counties are included?',
        desc: 'All counties in the 50 U.S. states are included in the search, excluding territories such as Puerto Rico, Guam, the U.S. Virgin Islands, and American Samoa.',
    },
    {
        id: 3,
        title: 'How long does a County and Federal check take?',
        desc: 'The turnaround time for a county or federal check varies based on the individual and the county involved, if applicable. On average, a county check takes 2-3 working days, and a federal check takes 1-2 days. These are just average values and can vary due to factors such as court closures.',
    },
    {
        id: 4,
        title: 'What is the Global Watchlist Report?',
        desc: (
            <>
                The Global Watchlist Report is a comprehensive verification tool that screens
                individuals against an extensive database comprising over 60 international sanctions
                and watchlists.
                <br />
                The report is available if there’s an indication that the user’s name is found on a
                watchlist. This process is crucial for enhancing compliance and security measures
                within organizations.{' '}
            </>
        ),
        linkText: 'Learn more',
        link: 'https://info.authenticate.com/global-watchlist-report',
    },
];
